/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const AboutTimming = ({ provider, saloon }) => {
  const { Services, Provider: Providers } = useSelector((state) => state.auth);
  const mapStyles = {
    height: "400px",
    width: "100%",
  };
console.log(saloon,'iner')
  const defaultCenter = {
    lat: 0,
    lng: 0,
  };
  // const [location, setLocation] = useState(defaultCenter);
  const [zoom, setZoom] = useState(13);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const geocodeAddress = async (address) => {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            address
          )}&key=AIzaSyDXJS_VZMhnp0szh92aZGg8RHszz6RMQN8`
        );
        const data = await response.json();
        if (data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          setLocation({ lat, lng });
          setZoom(15); // Zoom set for specific address
        } else {
          console.error("No results found for address.");
        }
      } catch (error) {
        console.error("Geocoding error:", error);
      } finally {
        setLoading(false);
      }
    };
    if (saloon?.address) {
      geocodeAddress(
        saloon?.address
        // provider?.length > 0
        //   ? provider[0]?.address
        //   : Providers?.provider_category_detail?.address
      );
    } else {
      // Agar address na ho, toh user ki current location dikhayen
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            });
            setZoom(14);
            setLoading(false);
          },
          (error) => {
            console.error("Geolocation error:", error);
            setLoading(false);
          }
        );
      }
    }
  }, [provider]);

  const containerStyle = {
    width: "100%",
    height: "500px",
  };

  const apiKey = "AIzaSyDXJS_VZMhnp0szh92aZGg8RHszz6RMQN8";
  const [location, setLocation] = useState(null);

  useEffect(() => {
    const fetchCoordinates = async () => {
      const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        saloon?.address
        // provider?.length > 0
        //   ? provider[0]?.address
        //   : Providers?.provider_category_detail?.address
      )}&key=${apiKey}`;
      try {
        const response = await fetch(geocodeUrl);
        const data = await response.json();
        if (data.status === "OK") {
          const { lat, lng } = data.results[0].geometry.location;
          setLocation({ lat, lng });
        }
      } catch (error) {
        console.error("Error fetching geocode:", error);
      }
    };

    fetchCoordinates();
  }, []);

  // if (!location) {
  //   return <div>Loading map...</div>; // Loading message jab tak location nahi aata
  // }
console.log(saloon,'atasssssssss')
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-7 col-12 mt-5">
            {/* <h1 className="text-dark">About</h1>
            <p
              className="text-dark font-weight-bold"
              style={{ fontWeight: "600" }}
            >
              {saloon?.about}
            </p> */}

            <LoadScript googleMapsApiKey={apiKey}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={location}
                zoom={15}
              >
                <Marker
                  position={location}
                  title={
                    saloon?.address
                    // provider?.length > 0
                    //   ? provider[0]?.address
                    //   : Providers?.provider_category_detail?.address
                  }
                />
              </GoogleMap>
            </LoadScript>
            <div className="row gy-2 mt-4">
              <div className="col-md-6 col-12">
                <h2 className="text-dark">Opening times</h2>
                <div className="row mt-3">
                  <div className="col-md-6 col-6 mt-2">
                    {  saloon?.provider_opening_times?.map((d, idx) => (
                      <div
                        key={idx}
                        className="d-flex align-items-center gap-1"
                      >
                        <div
                          className="circel"
                          style={{ backgroundColor: "#78D240" }}
                        ></div>
                        <h6 className="mt-2">{d.day}</h6>
                      </div>
                    ))}
                  </div>
                  <div className="col-md-6 col-6 mt-3">
                    {saloon?.provider_opening_times?.map((d, idx) => (
                      <h6
                        key={idx}
                        style={{ marginTop: idx !== 0 ? "15px" : "" }}
                      >
                        {d.open} - {d.close}
                      </h6>
                    ))}
                  </div>
                </div>
              </div>

              {/* <div className="col-md-6 col-12 mt-4">
                <h4 className="text-dark">Additional information</h4>
                {saloon?.provider_additional_features?.map((e, idx) => (
                  <h6 key={idx}>{e.name}</h6>
                ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutTimming;
